import {
  Squares2X2Icon,
  UsersIcon,
  PlusCircleIcon,
  DocumentTextIcon,
  CurrencyDollarIcon,
  VideoCameraIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

export interface NavItem {
  label: string;
  path: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children?: NavItem[];
}

export const navigation: NavItem[] = [
  { label: 'Dashboard', path: '/', icon: Squares2X2Icon },
  {
    label: 'Plans',
    path: '/plans',
    icon: DocumentTextIcon,
    children: [
      { label: 'Tous les plans', path: '/plans', icon: DocumentTextIcon },
      { label: 'Créer un plan', path: '/plans/create', icon: PlusCircleIcon },
    ],
  },
  { label: 'Utilisateurs', path: '/users', icon: UsersIcon },
  { label: 'Vidéos', path: '/videos', icon: VideoCameraIcon },
  { label: 'Stripe', path: '/stripe', icon: CurrencyDollarIcon },
  { label: 'Beta allowlist', path: '/beta-allowlist', icon: ShieldCheckIcon },
];
